import React from "react";
import BasicMessage from "./BasicMessage";
import scanningIcon from "common-ui-components/components/icons/scanning.svg";

const statusStyles = {
  inProgress: { color: "#2F7EE9" },
  success:    { color: "#2E7D32" },
  failed:     { color: "#C62828" },
  timedOut:   { color: "#D4A017" },
};

const PatchScanSummaryAlert = ({ apiResponse }) => {
  const { success, inProgress, failed, timedOut } = apiResponse?.response ?? {};

  const activeStatuses = [
    inProgress > 0 && { label: "In Progress", count: inProgress, style: statusStyles.inProgress },
    success    > 0 && { label: "Success",     count: success,    style: statusStyles.success },
    failed     > 0 && { label: "Failed",      count: failed,     style: statusStyles.failed },
    timedOut   > 0 && { label: "Timed Out",   count: timedOut,   style: statusStyles.timedOut },
  ].filter(Boolean);

  const title = inProgress > 0 ? "Scan status" : "Scan summary";

  return (
    <BasicMessage
      title={title}
      status={"information"}
      icon={inProgress > 0 ? scanningIcon : undefined}
    >
      <span style={{ display: "flex", gap: "0.3rem", fontWeight: 600, flexWrap: "wrap" }}>
        {activeStatuses.map((s, index) => (
          <React.Fragment key={s.label}>
            <span style={s.style}>{s.label}: {s.count}</span>
            {index < activeStatuses.length - 1 && (
              <span style={{ color: "#1a1a1a" }}>,</span>
            )}
          </React.Fragment>
        ))}
      </span>
    </BasicMessage>
  );
};

export default PatchScanSummaryAlert;